// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"787":"df5a9c36","3569":"df5a9c36","4536":"3c039f77","7811":"df5a9c36"}[chunkId] + ".chunk.css";
};